export const getFileFormatsText = (formats: string[]) =>
  formats.map((format) => format.replace('.', '').toUpperCase()).join(', ');
